export function accordionPromo() {
    $('.accordion-promo').each(function() {
        const $promo = $(this);

        $promo.find('.accordion-collapse.show').closest('.accordion-item').addClass('active');

        const promoObserver = new IntersectionObserver((entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting) {
                    $promo.find('.accordion-image.active').addClass('image-animate');
                    promoObserver.unobserve(entry.target);
                }
            });
        }, { threshold: 0.1 });
        promoObserver.observe($promo[0]);

        let opening = false;

        $promo.find('.accordion').on('show.bs.collapse', function(e) {
            opening = true;
            const $panel = $(e.target);
            const index = $panel.data('accordion-image');
            $(this).find('.accordion-item').removeClass('active');
            $panel.closest('.accordion-item').addClass('active');

            const $images = $promo.find('.accordion-image');
            $images.removeClass('active image-animate');
            const $next = $images.eq(index).addClass('active');
            $next[0].offsetWidth; // force reflow so animation replays
            $next.addClass('image-animate');
        }).on('shown.bs.collapse', function() {
            opening = false;
        }).on('hide.bs.collapse', function(e) {
            if (!opening) {
                e.preventDefault();
                return;
            }
            $(e.target).closest('.accordion-item').removeClass('active');
        });
    });
}